import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { TabStrip } from "../../core/components/tabStrip";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import EditTranslations from "../editTranslations";
import { TextBox, TextBoxProps } from "../../core/components/textBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { DropDownList, DropDownListProps } from "../../core/components/dropDownList";
import { GetNextNumber, GetNextNumberProps } from "../../core/components/getNextNumber";
import { ContextGeneralSettingsApp, GeneralSettingsEntity } from "../generalSettings";
import { Metadata } from "../../core/components/commonApp";
import { CommandManagerAPI } from "../../commonInterfaces";
import React from "react";
export default class FaultCodes extends React.Component<FaultCodesProps, any> {
    private _factory = ComponentHelper.createFactory();
    private _faultCodes: FaultCodesViewModel = null;
    private _selectedFaultLocation: FaultCode = null;
    private _selectedFaultCode: FaultCode = null;
    private _selectedCauseCode: FaultCode = null;
    private _selectedRepairCode: FaultCode = null;
    private _editTranslationsRef: EditTranslations = null;
    private _tabStripRef: TabStrip = null;
    private _htmlElement: HTMLElement = null;
    private _gridReferences = {
        gridFaultLocations: null,
        gridFaultCodes: null,
        gridCauseCodes: null,
        gridRepairCodes: null
    }
    private _metaDataTabs: Metadata = {
        tabs: [],
        additional: {
            objects: []
        }
    };
    private _editDialogState: EditDialogState = {
        IsOpen: false,
        IsNew: false,
        Type: null,
        FaultCode: null,
    };
    private _editDialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._editDialogState.FaultCode.Code === null || this._editDialogState.FaultCode.Code === ""
                        || this._editDialogState.FaultCode.Text === null || this._editDialogState.FaultCode.Text === "") {
                        DialogHelper.alert(this.props.context.translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }

                    this._save();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this._editDialogState.IsOpen = false;
            this.setState({});
        },
        width: 500
    };
    private _addExisitingDialogState: AddExisitingDialogState = {
        IsOpen: false,
        ParentCodeType: null,
        ParentFaultCode: null,
        SelectionList: [],
        SelectionCode: null
    };
    private _addExistingDialogProps: DialogProps = {
        title: Config.translations.add,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._addExisitingDialogState.SelectionCode === null || this._addExisitingDialogState.SelectionCode === "") {
                        DialogHelper.alert(this.props.context.translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }

                    this._makeReference();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this._addExisitingDialogState.IsOpen = false;
            this.setState({});
        },
        width: 500
    };

    constructor(props) {
        super(props);

        this._metaDataTabs.tabs.push({
            title: this.props.context.translations["WebSMS.Procedure.LocationCode"],
            component: "renderGridFaultLocations()"
        });
        this._metaDataTabs.tabs.push({
            title: this.props.context.translations["WebSMS.Procedure.FaultCode"],
            component: "renderGridFaultCodes()",
            visible: "!faultCodes.ReferencesActivated || selectedFaultLocation !== null"
        });
        this._metaDataTabs.tabs.push({
            title: this.props.context.translations["WebSMS.Procedure.CauseCode"],
            component: "renderGridCauseCodes()",
            visible: "!faultCodes.ReferencesActivated || selectedFaultCode !== null"
        });
        this._metaDataTabs.tabs.push({
            title: this.props.context.translations["WebSMS.Procedure.RectificationCode"],
            component: "renderGridRepairCodes()",
            visible: "!faultCodes.ReferencesActivated || selectedCauseCode !== null"
        });

        this._loadFaultCodes();
    }

    private _getTabellenId(type: "FaultLocation" | "FaultCode" | "CauseCode" | "RepairCode") {
        if (type == "FaultLocation")
            return 291;
        else if (type == "FaultCode")
            return 296;
        else if (type == "CauseCode")
            return 300;
        else if (type == "RepairCode")
            return 266;
    }

    private _handleEval = (expression: string, additional: any = null) => {
        const localAdditional = $.extend({}, additional, {
            renderGridFaultLocations: this.renderGridFaultLocations,
            renderGridFaultCodes: this.renderGridFaultCodes,
            renderGridCauseCodes: this.renderGridCauseCodes,
            renderGridRepairCodes: this.renderGridRepairCodes,
            faultCodes: this._faultCodes,
            selectedFaultLocation: this._selectedFaultLocation,
            selectedFaultCode: this._selectedFaultCode,
            selectedCauseCode: this._selectedCauseCode,
            selectedRepairCode: this._selectedRepairCode
        });
        return this.props.handleEval(expression, localAdditional);
    }

    private _loadFaultCodes = () => {
        HTTPService.get<JsonResultClass<FaultCodesViewModel>>("FaultCodes/GetFaultCodes")
            .then(result => {
                this._faultCodes = result.Data;
                this.setState({});
            });
    }

    private _handleSelectionChanged = (gridType: number, dataItem: FaultCode) => {
        console.log(gridType, dataItem)
        if (gridType == 1) {
            this._selectedFaultLocation = dataItem;
            this._selectedFaultCode = null;
            this._selectedCauseCode = null;
        }
        else if (gridType == 2) {
            this._selectedFaultCode = dataItem;
            this._selectedCauseCode = null;
        }
        else if (gridType == 3) {
            this._selectedCauseCode = dataItem;
        }
        else if (gridType == 4) {
            this._selectedRepairCode = dataItem;
        }
        if (this._faultCodes.ReferencesActivated)
            this.setState({});
    }

    private _handleStandardButtonClick = (gridType: number, type: ToolBarStandardButtonType, dataItem: FaultCode, allItems?: Array<FaultCode>) => {
        if (gridType == 1)
            this._editDialogState.Type = "FaultLocation";
        else if (gridType == 2)
            this._editDialogState.Type = "FaultCode";
        else if (gridType == 3)
            this._editDialogState.Type = "CauseCode";
        else if (gridType == 4)
            this._editDialogState.Type = "RepairCode";

        if (type == ToolBarStandardButtonType.NEW) {
            this._editDialogState.IsOpen = true;
            this._editDialogState.IsNew = true;
            this._editDialogState.FaultCode = { CodeType: null, Code: "", Text: "", Langtext: "", Isrowid: null, GermanLangtext: "", GermanText:"" };
            this.setState({});
        }
        else if (type == ToolBarStandardButtonType.EDIT) {
            this._editDialogState.IsOpen = true;
            this._editDialogState.IsNew = false;
            this._editDialogState.FaultCode = JSON.parse(JSON.stringify(dataItem));
            this.setState({})
        }
        else if (type == ToolBarStandardButtonType.DELETE) {
            this._editDialogState.FaultCode = JSON.parse(JSON.stringify(dataItem));

            DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
                if (isOk) {
                    this._delete();
                }
            });
        }
    }

    private _handleCustomButtonClick = (gridType: number, id: string, dataItem: FaultCode, allItems?: Array<FaultCode>) => {
        if (gridType == 2) {
            this._addExisitingDialogState.ParentCodeType = "FaultLocation";
            this._addExisitingDialogState.ParentFaultCode = this._selectedFaultLocation;
            this._addExisitingDialogState.SelectionList = this._faultCodes.FaultCodes.filter(x => {
                return this._faultCodes.References.filter(y => y.Codetype == 1 && y.Code == this._selectedFaultLocation.Code && y.Rcode == x.Code).length == 0
            });
        }
        else if (gridType == 3) {
            this._addExisitingDialogState.ParentCodeType = "FaultCode";
            this._addExisitingDialogState.ParentFaultCode = this._selectedFaultCode;
            this._addExisitingDialogState.SelectionList = this._faultCodes.CauseCodes.filter(x => {
                return this._faultCodes.References.filter(y => y.Codetype == 2 && y.Code == this._selectedFaultCode.Code && y.Rcode == x.Code).length == 0
            });
        }
        else if (gridType == 4) {
            this._addExisitingDialogState.ParentCodeType = "CauseCode";
            this._addExisitingDialogState.ParentFaultCode = this._selectedCauseCode;
            this._addExisitingDialogState.SelectionList = this._faultCodes.RepairCodes.filter(x => {
                return this._faultCodes.References.filter(y => y.Codetype == 3 && y.Code == this._selectedCauseCode.Code && y.Rcode == x.Code).length == 0
            });
        }

        if (id == "1") {
            this._addExisitingDialogState.IsOpen = true;
            this._addExisitingDialogState.SelectionCode = null;

            this.setState({});
        }
    }

    private _delete = () => {
        let doDelete = (deleteAllReferences: boolean, parentCode: string) => {
            HTTPService.post<JsonResultClass>("FaultCodes/Delete", { codeType: this._editDialogState.Type, faultCode: this._editDialogState.FaultCode, parentCode: parentCode, deleteAllReferences: deleteAllReferences })
                .then((result: JsonResultClass) => {
                    if (result.Code == 0) {
                        this._loadFaultCodes();
                    }
                    else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }

        let parentCode = null;
        let otherReferencesExist = false;
        if (this._faultCodes.ReferencesActivated) {
            if (this._editDialogState.Type == "FaultCode") {
                parentCode = this._selectedFaultLocation.Code;
                otherReferencesExist = this._faultCodes.References.filter(x => x.Codetype == 1 && x.Rcode == this._selectedFaultLocation.Code).length > 1;
            }
            else if (this._editDialogState.Type == "CauseCode") {
                parentCode = this._selectedFaultCode.Code;
                otherReferencesExist = this._faultCodes.References.filter(x => x.Codetype == 2 && x.Rcode == this._selectedCauseCode.Code).length > 1;
            }
            else if (this._editDialogState.Type == "RepairCode") {
                parentCode = this._selectedCauseCode.Code;
                otherReferencesExist = this._faultCodes.References.filter(x => x.Codetype == 3 && x.Rcode == this._selectedRepairCode.Code).length > 1;
            }
        }

        if (otherReferencesExist) {
            DialogHelper.confirm(this.props.context.translations["WebSMS.GeneralSettings.FaultCodes.ReferenzenLoeschen"]).then(isOk => {
                doDelete(isOk, parentCode);
            });
        }
        else
            doDelete(false, parentCode);
    }

    private _save = () => {
        let parentCode = null;
        if (this._faultCodes.ReferencesActivated) {
            if (this._editDialogState.Type == "FaultCode")
                parentCode = this._selectedFaultLocation.Code;
            else if (this._editDialogState.Type == "CauseCode")
                parentCode = this._selectedFaultCode.Code;
            else if (this._editDialogState.Type == "RepairCode")
                parentCode = this._selectedCauseCode.Code;
        }

        HTTPService.post<JsonResultClass>("FaultCodes/Save", { codeType: this._editDialogState.Type, faultCode: this._editDialogState.FaultCode, isNew: this._editDialogState.IsNew, parentCode: parentCode })
            .then(result => {
                if (result.Code == 0) {
                    this._loadFaultCodes();
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _makeReference = () => {
        HTTPService.post<JsonResultClass>(
            "FaultCodes/MakeReference",
            { codeType: this._addExisitingDialogState.ParentCodeType, code: this._addExisitingDialogState.SelectionCode, parentCode: this._addExisitingDialogState.ParentFaultCode.Code }
        )
            .then(result => {
                if (result.Code == 0) {
                    this._loadFaultCodes();
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _getStandardButtons = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: !this.props.disabled });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: !this.props.disabled });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: !this.props.disabled });
        return standardButtons;
    }

    private _getCustomButtons = () => {
        const customButtons: Array<GridCustomToolBarButton> = [];
        if (this._faultCodes.ReferencesActivated)
            customButtons.push({
                id: "1", caption: this.props.context.translations["WebSMS.GeneralSettings.FaultCodes.VorhandenenHinzufuegen"], iconClass: "k-i-plus", enabled: !this.props.disabled, autoEnabledOnRecordSelected: false });
        return customButtons;
    }

    private _filterFaultCodes = (allCodes: Array<FaultCode>, codeType: number, parentCode: FaultCode) => {
        let result: Array<FaultCode> = allCodes;
        if (this._faultCodes.ReferencesActivated && parentCode !== null) {
            let rCodes = this._faultCodes.References.filter(x => x.Codetype == codeType && x.Code == parentCode.Code).map((item, index) => { return item.Rcode })
            result = allCodes.filter(x => rCodes.indexOf(x.Code) != -1);
        }
        return result;
    }

    private _renderSelectionLabel = () => {
        let label = "";
        if (this._faultCodes !== null && this._faultCodes.ReferencesActivated) {
            if (this._selectedFaultLocation !== null)
                label = this._selectedFaultLocation.Text;
            if (this._selectedFaultCode !== null)
                label += " -> " + this._selectedFaultCode.Text;
            if (this._selectedCauseCode !== null)
                label += " -> " + this._selectedCauseCode.Text;
        }
        return <label style={{ height: this._faultCodes !== null && this._faultCodes.ReferencesActivated ? "20px" : "", marginTop: "10px", marginBottom: "10px", marginLeft: "5px" }}>{label}</label>
    }

    renderGridFaultLocations = () => {
        return (
            <Grid ref={(r) => this._gridReferences.gridFaultLocations = r} data={this._faultCodes.FaultLocations} options={this.props.context.faultCodesGridOptions} id="FaultCodes_FaultLocations"
                standardButtons={this._getStandardButtons()} onClickStandardButton={(type: ToolBarStandardButtonType, dataItem: FaultCode) => this._handleStandardButtonClick(1, type, dataItem)}
                onSelectionChanged={(dataItem: FaultCode) => this._handleSelectionChanged(1, dataItem)}
            />
        );
    }

    renderGridFaultCodes = () => {
        let codes = this._filterFaultCodes(this._faultCodes.FaultCodes, 1, this._selectedFaultLocation);

        return (
            <Grid ref={(r) => this._gridReferences.gridFaultCodes = r} data={codes} options={this.props.context.faultCodesGridOptions} id="FaultCodes_FaultCodes"
                standardButtons={this._getStandardButtons()} onClickStandardButton={(type: ToolBarStandardButtonType, dataItem: any) => this._handleStandardButtonClick(2, type, dataItem)}
                onSelectionChanged={(dataItem: FaultCode) => this._handleSelectionChanged(2, dataItem)}
                customButtons={this._getCustomButtons()} onClickCustomButton={(id: string, dataItem: any) => this._handleCustomButtonClick(2, id, dataItem)}
            />
        );
    }

    renderGridCauseCodes = () => {
        let codes = this._filterFaultCodes(this._faultCodes.CauseCodes, 2, this._selectedFaultCode);

        return (
            <Grid ref={(r) => this._gridReferences.gridCauseCodes = r} data={codes} options={this.props.context.faultCodesGridOptions} id="FaultCodes_CauseCodes"
                standardButtons={this._getStandardButtons()} onClickStandardButton={(type: ToolBarStandardButtonType, dataItem: any) => this._handleStandardButtonClick(3, type, dataItem)}
                onSelectionChanged={(dataItem: FaultCode) => this._handleSelectionChanged(3, dataItem)}
                customButtons={this._getCustomButtons()} onClickCustomButton={(id: string, dataItem: any) => this._handleCustomButtonClick(3, id, dataItem)}
            />
        );
    }

    renderGridRepairCodes = () => {
        let codes = this._filterFaultCodes(this._faultCodes.RepairCodes, 3, this._selectedCauseCode);

        return (
            <Grid ref={(r) => this._gridReferences.gridRepairCodes = r} data={codes} options={this.props.context.faultCodesGridOptions} id="FaultCodes_RepairCodes"
                standardButtons={this._getStandardButtons()} onClickStandardButton={(type: ToolBarStandardButtonType, dataItem: any) => this._handleStandardButtonClick(4, type, dataItem)}
                onSelectionChanged={(dataItem: FaultCode) => this._handleSelectionChanged(4, dataItem)}
                customButtons={this._getCustomButtons()} onClickCustomButton={(id: string, dataItem: any) => this._handleCustomButtonClick(4, id, dataItem)}
            />
        );
    }

    private _renderEditDialog = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }
        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }

        let textBoxCode: GetNextNumberProps = null;
        let textBoxText: TextBoxProps = null;
        let textBoxLangtext: TextBoxProps = null;
        if (this._editDialogState.IsOpen) {
            textBoxCode = this._factory.getDefaultNextNumberProps();
            textBoxCode.value = this._editDialogState.FaultCode.Code;
            textBoxCode.disabled = this._editDialogState.FaultCode.Isrowid !== null;
            textBoxCode.onChange = (field: { model: string }, value: any) => {
                this._editDialogState.FaultCode.Code = value;
                this.setState({});
            };
            textBoxCode.field.url = "FaultCodesLookUp/GetNextFaultCode?CodeType=" + this._editDialogState.Type;

            textBoxText = this._factory.getDefaultTextBoxProps();
            textBoxText.value = this._editDialogState.FaultCode.Text;
            textBoxText.onChange = (field: { model: string }, value: any) => {
                this._editDialogState.FaultCode.Text = value;
            };

            textBoxLangtext = this._factory.getDefaultTextBoxProps();
            textBoxLangtext.field.multiLine = true;
            textBoxLangtext.value = this._editDialogState.FaultCode.Langtext === null ? "" : this._editDialogState.FaultCode.Langtext
            textBoxLangtext.onChange = (field: { model: string }, value: any) => {
                this._editDialogState.FaultCode.Langtext = value;
            };
        }

        let dropDownCodeSelection: DropDownListProps = null;
        if (this._addExisitingDialogState.IsOpen) {
            dropDownCodeSelection = this._factory.getDefaultDropDownProps();
            dropDownCodeSelection.dataSource = this._addExisitingDialogState.SelectionList;
            dropDownCodeSelection.field.dataTextField = "Text";
            dropDownCodeSelection.field.dataValueField = "Code";
            dropDownCodeSelection.onChange = (field: { model: string }, value: any) => {
                this._addExisitingDialogState.SelectionCode = value;
            };
        }

        return (
            <>
                <Dialog {...this._addExistingDialogProps} open={this._addExisitingDialogState.IsOpen}>
                    {
                        this._addExisitingDialogState.IsOpen ?
                            <div>
                                <FieldInstance label={this.props.context.translations["Standard.Code"]} noHover={true} >
                                    <DropDownList {...dropDownCodeSelection} />
                                </FieldInstance>
                            </div>
                            : null
                    }
                </Dialog>

                <Dialog {...this._editDialogProps} open={this._editDialogState.IsOpen}>
                    {
                        this._editDialogState.IsOpen ?
                            <div>
                                <FieldInstance label={this.props.context.translations["Standard.Code"] + "*"} noHover={true} >
                                    <GetNextNumber {...textBoxCode} />
                                </FieldInstance>
                                <FieldInstance label={this.props.context.translations["Standard.Beschreibung"] + "*"} noHover={true}>
                                    <TextBox {...textBoxText} />
                                </FieldInstance>
                                {
                                    this._editDialogState.FaultCode.Isrowid !== null ?
                                        <FieldInstance noLabel={true}>
                                            <div style={divStyle}>
                                                <label style={labelStyle} onClick={() => {
                                                    this._editTranslationsRef.openDialog(this._editDialogState.FaultCode.Isrowid, this._getTabellenId(this._editDialogState.Type), "value_0", this._editDialogState.FaultCode.GermanText);
                                                }}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}</label>
                                            </div>
                                        </FieldInstance>
                                        : null
                                }
                                <FieldInstance label={this.props.context.translations["Field.Material.Langtext"]} noHover={true}>
                                    <TextBox {...textBoxLangtext} />
                                </FieldInstance>
                                {
                                    this._editDialogState.FaultCode.Isrowid !== null ?
                                        <FieldInstance noLabel={true}>
                                            <div style={divStyle}>
                                                <label style={labelStyle} onClick={() => {
                                                    this._editTranslationsRef.openDialog(this._editDialogState.FaultCode.Isrowid, this._getTabellenId(this._editDialogState.Type), "value_text_0", this._editDialogState.FaultCode.GermanLangtext);
                                                }}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}</label>
                                            </div>
                                        </FieldInstance>
                                        : null
                                }
                                <EditTranslations
                                    ref={(r) => this._editTranslationsRef = r}
                                    label={Config.translations.editLabel}
                                    saveGerman={(value: string, target: "value_0" | "value_1" | "value_text_0") => {
                                        if (target == "value_0") {
                                            this._editDialogState.FaultCode.GermanText = value;
                                        } else if (target == "value_text_0") {
                                            this._editDialogState.FaultCode.GermanLangtext = value;
                                        }
                                    }}
                                />
                            </div>
                            : null
                    }
                </Dialog>
            </>
        );
    }

    componentDidMount() {
        $(this._htmlElement).on("click", "a", (ev) => {
            const $target = $(ev.target);
            if ($target.data("code-link") !== undefined && $target.data("id") !== undefined && $target.data("id2") !== undefined) {
                let codeType: "FaultLocation" | "FaultCode" | "CauseCode" | "RepairCode" = $target.data("id");
                let code = $target.data("id2");

                let grid: Grid = null;
                let activateIndex = 0;
                if (codeType == "FaultLocation") {
                    grid = this._gridReferences.gridFaultLocations;
                    activateIndex = 1;
                }
                else if (codeType == "FaultCode") {
                    grid = this._gridReferences.gridFaultCodes;
                    activateIndex = 2;
                }
                else if (codeType == "CauseCode") {
                    grid = this._gridReferences.gridCauseCodes;
                    activateIndex = 3;
                }
                else if (codeType == "RepairCode") {
                    grid = this._gridReferences.gridRepairCodes;
                    activateIndex = 3;
                }

                const toSelect = $("tr", grid.getGridRef().tbody).filter((index, row) => {
                    return $(row).find(`td:first:contains('${code}')`).length > 0;
                });
                toSelect.click();
                grid.getGridRef().select(toSelect);
                

                if (this._faultCodes.ReferencesActivated)
                    this._tabStripRef.getTabStripRef().select(activateIndex);
            }
        });
    }


    render() {
        return (
            <div ref={(r) => this._htmlElement = r} className="flex-container__item flex-container">
                {this._renderEditDialog()}
                {this._renderSelectionLabel()}
                {
                    this._faultCodes !== null ?
                        <TabStrip ref={(r) => this._tabStripRef = r} metadata={this._metaDataTabs} entity={this.props.entity} dataSources={{}} horizontal={true}
                            onChange={this.props.onChange} onDataLoaded={null}
                            handleEval={this._handleEval} handleIsSearchFieldFullObjectModel={null}
                            handleIndividulFieldsMetaDataCreated={null}
                            commandManager={this.props.commandManager} />
                        : null
                }
            </div>
        );
    }
}

interface FaultCodesProps {
    handleEval(expression: string, additional?: any);
    onChange(field: { model: string }, value: any, dataItem?: any);
    entity: GeneralSettingsEntity;
    commandManager: CommandManagerAPI;
    context: ContextGeneralSettingsApp;
    disabled: boolean;
}

interface FaultCodesViewModel {
    ReferencesActivated: boolean;
    FaultLocations: Array<FaultCode>;
    FaultCodes: Array<FaultCode>;
    CauseCodes: Array<FaultCode>;
    RepairCodes: Array<FaultCode>;
    References: Array<FaultCodeReference>;
}

interface FaultCode {
    CodeType: "FaultLocation" | "FaultCode" | "CauseCode" | "RepairCode";
    Code: string;
    Text: string;
    GermanText: string;
    Langtext: string;
    GermanLangtext: string;
    Isrowid: number;
}

interface FaultCodeReference {
    Codetype: number;
    Code: string;
    Rcode: string;
}

interface EditDialogState {
    IsOpen: boolean;
    IsNew: boolean;
    Type: "FaultLocation" | "FaultCode" | "CauseCode" | "RepairCode"
    FaultCode: FaultCode;
}

interface AddExisitingDialogState {
    IsOpen: boolean;
    ParentCodeType: "FaultLocation" | "FaultCode" | "CauseCode" | "RepairCode"
    ParentFaultCode: FaultCode;
    SelectionList: Array<FaultCode>;
    SelectionCode: string;
}